import { render, staticRenderFns } from "./Sectores.vue?vue&type=template&id=0e13e89e&scoped=true&"
import script from "./Sectores.vue?vue&type=script&lang=js&"
export * from "./Sectores.vue?vue&type=script&lang=js&"
import style0 from "./Sectores.vue?vue&type=style&index=0&id=0e13e89e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e13e89e",
  null
  
)

export default component.exports